import { Controller, useFormContext } from 'react-hook-form';

import KDSTextArea, {
  TextAreaProps as KDSTextAreaProps,
} from '@decisiv/ui-components/lib/components/TextArea';

interface TextAreaProps extends Omit<KDSTextAreaProps, 'value'> {
  name: string;
  defaultValue?: string;
  warningMessage?: string;
}

const TextField = ({
  name,
  defaultValue,
  warningMessage,
  ...props
}: TextAreaProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => (
        <KDSTextArea
          value={value}
          onChange={({ target }) => onChange(target.value)}
          warningMessage={errors[name]?.message?.toString() || warningMessage}
          {...props}
        />
      )}
    />
  );
};

export default TextField;
